"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _radioButton = _interopRequireDefault(require("../radioButton/radioButton"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _radioButtonGroupModule = _interopRequireDefault(require("./radioButtonGroup.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RadioButtonGroup = function RadioButtonGroup(props) {
  var options = props.options,
      _onChange = props.onChange,
      id = props.id,
      value = props.value,
      horizontal = props.horizontal,
      labelStyle = props.labelStyle,
      style = props.style,
      wrapperStyle = props.wrapperStyle,
      required = props.required,
      name = props.name;
  return _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(_themeModule.default.arag, horizontal ? _radioButtonGroupModule.default['radioGroupHorizontalWrapper'] : _radioButtonGroupModule.default['radioButtonGroupWrapper'], wrapperStyle)
  }, options.map(function (_ref) {
    var label = _ref.label,
        id = _ref.id,
        disabled = _ref.disabled,
        item = _objectWithoutProperties(_ref, ["label", "id", "disabled"]);

    return _react.default.createElement(_radioButton.default, _extends({}, item, {
      label: label,
      onChange: function onChange() {
        return _onChange(id);
      },
      name: name,
      disabled: disabled,
      horizontal: horizontal,
      labelStyle: labelStyle,
      style: style,
      required: required,
      id: id,
      value: value
    }));
  }));
};

RadioButtonGroup.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** Array specifies the group of radio buttons */
  options: _propTypes.default.arrayOf(_propTypes.default.object),

  /** Callback fun for select.*/
  onChange: _propTypes.default.func,

  /** value.*/
  value: _propTypes.default.string,

  /** horizontal display**/
  horizontal: _propTypes.default.bool,

  /**add additional label style **/
  labelStyle: _propTypes.default.object,

  /**add additional style **/
  style: _propTypes.default.object,

  /** additional style for wrapper div element **/
  wrapperStyle: _propTypes.default.any,

  /** Boolean indicating if the component is required  */
  required: _propTypes.default.bool,

  /** The name attribute of the element */
  name: _propTypes.default.string.isRequired
};
var _default = RadioButtonGroup;
exports.default = _default;